import styled from 'styled-components'
import { ScoreVariant } from './ScoreDisplay.types'

export const Container = styled.div<{
  $variant?: ScoreVariant
  $withProgress?: boolean
  $clickable?: boolean
}>`
  display: flex;
  align-items: ${({ $withProgress }) =>
    $withProgress ? 'stretch' : 'baseline'};
  flex-direction: ${({ $withProgress }) => ($withProgress ? 'column' : 'row')};
  gap: ${({ $withProgress }) => ($withProgress ? '8px' : '12px')};
  padding: 4px 20px;
  background: ${({ theme }) => theme.colors.background.tertiary};
  border-radius: 8px;
  transition: all 0.2s ease;
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};

  &:hover {
    box-shadow: ${({ theme }) => theme.shadows.sm};
  }

  @media (max-width: 768px) {
    width: 100%;
    justify-content: center;
  }
`

export const ScoreContainer = styled.div`
  display: flex;
  align-items: baseline;
  gap: 4px;
`

export const ScoreValue = styled.span<{ $variant?: ScoreVariant }>`
  font-size: 32px;
  font-weight: 600;
  color: ${({ theme, $variant }) => {
    switch ($variant) {
      case 'warning':
        return theme.colors.warning
      case 'success':
        return theme.colors.success
      case 'danger':
        return theme.colors.danger
      case 'primary':
        return theme.colors.primary
      default:
        return theme.colors.text.primary
    }
  }};

  @media (max-width: 768px) {
    font-size: 28px;
  }
`

export const ScoreMax = styled.span`
  font-size: 16px;
  color: ${({ theme }) => theme.colors.text.secondary};

  @media (max-width: 768px) {
    font-size: 14px;
  }
`

export const ScoreLabel = styled.div`
  font-size: 13px;
  color: ${({ theme }) => theme.colors.text.secondary};
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;

  @media (max-width: 480px) {
    font-size: 12px;
  }
`

export const InfoIcon = styled.span`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.primary};
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 600;
  cursor: help;
  transition: all 0.2s ease;

  &:hover {
    background: ${({ theme }) => theme.colors.primary};
    transform: scale(1.1);
  }
`

export const ProgressBarContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const ProgressBar = styled.div`
  height: 4px;
  background: rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  overflow: hidden;
  width: 200px;
`

export const ProgressFill = styled.div<{
  $variant?: ScoreVariant
  $width: number
}>`
  height: 100%;
  background: ${({ theme, $variant }) => {
    switch ($variant) {
      case 'warning':
        return theme.colors.warning
      case 'success':
        return theme.colors.success
      case 'danger':
        return theme.colors.danger
      case 'primary':
        return theme.colors.primary
      default:
        return theme.colors.primary
    }
  }};
  transition: width 0.6s ease;
  border-radius: 2px;
  width: ${({ $width }) => $width}%;
`
